import React from 'react'
import { Col, Row } from 'react-bootstrap'

const PageTitle = ({title}) => {
  return (
    <Row>

        <Col md={6}>

            <h3 className="page-title">{title}</h3>
        
        </Col>

    </Row>
  )
}

export default PageTitle